import CustomerInformations from './CustomerInformations';
import CustomerDetails from './CustomerDetails';
import CustomerAddress from './CustomerAddress';
import CustomerQuotation from './CustomerQuotation';
import Account from './SFModels/Account';
import ShippingAddress from './SFModels/ShippingAddress';
import Opportunity from './SFModels/Opportunity';
import Quotation from './SFModels/Quotation';
import Stage from './Stage';

const TYPE_MAP = {
  CustomerInformations: CustomerInformations.deserialize,
  CustomerDetails: CustomerDetails.deserialize,
  CustomerAddress: CustomerAddress.deserialize,
  CustomerQuotation: CustomerQuotation.deserialize,
  Account: Account.deserialize,
  ShippingAddress: ShippingAddress.deserialize,
  Opportunity: Opportunity.deserialize,
  Quotation: Quotation.deserialize,
  Stage: Stage.deserialize,
};

export function deserialize(raw, type) {
  if (TYPE_MAP.hasOwnProperty(type)) {
    return TYPE_MAP[type](raw);
  }

  return raw;
}



// WEBPACK FOOTER //
// ./src/models/index.js